import {TutorialSvc, TutorialSvcFactory} from '../services/TutorialSvc';

class youtubeModalCtrl {
    static TutorialSvcCache: {[s: string]: TutorialSvc} = {};
    videoDuration: string;
    videoId: string;
    author: string;
    videoName: string;
    videoDesc: string;
    thumbnail: string;
    slug: string;
    TutorialSvc: TutorialSvc;

    constructor($transclude: ng.ITranscludeFunction,
                TutorialSvcFactory: TutorialSvcFactory,
                $location: ng.ILocationService,
                $timeout: ng.ITimeoutService,
                $stateParams: any,
                $state: ng.ui.IStateService) {
        this.TutorialSvc = youtubeModalCtrl.TutorialSvcCache[$location.path()] ||
            (youtubeModalCtrl.TutorialSvcCache[$location.path()] = new TutorialSvcFactory());

        this.TutorialSvc.getVideo(this.videoId).then(video => {
            this.videoDuration = this.TutorialSvc.calcTime(video.duration);
            this.videoName = video.title;
            this.videoDesc = video.description;
            this.thumbnail = video.thumbnails.default.url.replace('http:', 'https:');
            this.slug = video.slug;

            $transclude(clone => $timeout(() => {
                const text = clone.text();

                if (text) {
                    this.videoDesc = text;
                    this.TutorialSvc.setVideoDescription(this.videoId, text)
                }
            }));

            if ($state.is('studio-tutorial') && $stateParams.video === video.slug) {
                this.showVideo();
            }
        });
        this.TutorialSvc.addToQueue(this.videoId);
    }

    showVideo() {
        this.TutorialSvc.openModal(this.videoId, parseInt(this.author, 10));
    }
}

angular.module('animatronApp.tutorial')
    .component('youtubeModal', {
        controller: youtubeModalCtrl,
        controllerAs: 'youtubeModalCtrl',
        transclude: true,
        bindings: {
            videoId: '@',
            author: '@'
        },
        template: `<a ng-href="/studio/tutorial/{{::youtubeModalCtrl.slug}}"
                      ng-click="youtubeModalCtrl.showVideo()" eat-click>
                        <span class="yt-tutorail-preview-wrapper">
                            <img class="yt-tutorial-preview" ng-src="{{::youtubeModalCtrl.thumbnail}}" style="width:72px; height: 48px" />
                        </span>
                        <span class="name">{{::youtubeModalCtrl.videoName}}</span>
                        <span class="duration">{{::youtubeModalCtrl.videoDuration}} min</span>
                   </a>
                   <div class="description">{{youtubeModalCtrl.videoDesc}}</div>`
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/youtubeModalDirective.ts